import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const selfCorrection: BlogMetaData = {
  title: '子どもが間違えた時、怒ってないですか？理想は子ども自ら間違いを訂正することです！',
  description:
    'モンテッソーリ教育で大切にされてる「間違いの自己訂正」について解説します。日々の子育てのヒントになると嬉しいです！',
  thumbnailUrl: '/img/blog-self_correction-thumbnail.webp',
  filePath: buildBlogFilePath('self_correction'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
